/**
 * @fileoverview Composes state and handlers for the Reports page.
 * @module pages/reports/useReports
 */
import useReportsContext from "./useReportsContext.js";
import useReportsHandlers from "./useReportsHandlers.js";
import { buildReportsViewModel } from "./buildReportsViewModel.js";

/** View-model hook for the Reports page. */
const useReports = () => {
  const ctx = useReportsContext();
  const handlers = useReportsHandlers(ctx);
  return buildReportsViewModel(ctx, handlers);
};

export default useReports;
